import { useQuery } from 'react-query';
import useLocalStorage from 'react-use/lib/useLocalStorage.js';
import { addDays } from 'date-fns';

import { useFirebase } from 'components/Firebase/index.js';

const ONE_DAY_TTL = 1;

const INITIAL_SUBSCRIPTION_STORAGE_VALUE = {
  subscriptions: [],
  timestamp: 0,
};

const useClientSubscriptions = (clientId) => {
  const firebase = useFirebase();
  const storageKey = `client-${clientId}-subscriptions`;

  const [storage, setStorage] = useLocalStorage(storageKey, INITIAL_SUBSCRIPTION_STORAGE_VALUE);
  const { subscriptionInfo, timestamp } = storage;
  const isStorageExpired = addDays(new Date(timestamp), ONE_DAY_TTL) < new Date();
  const shouldFetchSubscriptions = isStorageExpired && !!clientId;

  const { data: fetchedSubscriptions, ...rest } = useQuery({
    enabled: shouldFetchSubscriptions,
    retry: 3,
    queryKey: ['clients', clientId, 'subscriptions'],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const response = await agent.get(`/clients/${clientId}/subscriptions`);
      return response.body;
    },
    onSuccess: (data) => {
      setStorage({ subscriptionInfo: data, timestamp: new Date() });
    },
    onError: (error) => {
      console.error('Failed to fetch client subscriptions', error.message);
      !!clientId && setStorage({
        ...INITIAL_SUBSCRIPTION_STORAGE_VALUE,
        timestamp: new Date(),
      });
    },
  });

  return { data: isStorageExpired ? fetchedSubscriptions : subscriptionInfo, ...rest };
};

export default useClientSubscriptions;
